import { EUserStatusActionTypes } from '../../actions/userStatus';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';
import { getUserStatusDiff } from '../../utils/getUserStatusDiff';

export function usersStatusReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EUserStatusActionTypes.Set:
      return {
        ...state,
        usersStatus: {
          ...state.usersStatus,
          [action.payload.userId]: {
            lastActionDatetime: action.payload.lastActionDatetime,
            statusDiffStr: getUserStatusDiff(action.payload.lastActionDatetime),
          },
        },
      };

    case EUserStatusActionTypes.Update:
      const lastActionDatetime = state.usersStatus[action.payload.userId].lastActionDatetime;

      return {
        ...state,
        usersStatus: {
          ...state.usersStatus,
          [action.payload.userId]: {
            lastActionDatetime,
            statusDiffStr: getUserStatusDiff(lastActionDatetime),
          },
        },
      };
    default:
      return state;
  }
}
